import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { AlreadyInOrderAction } from '@/components/already-in-order-action';
import { Button } from '@/components/button';
import { StyleSheet } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useOrderInbounds } from '@/hooks/use-order-inbounds';

interface Props {
  isExistingVariantPack?: boolean;
  onSelect: () => void | Promise<void>;
}

export const InboundRenderActions: React.FC<Props> = ({
  isExistingVariantPack = false,
  onSelect,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { isViewOnly } = useOrderInbounds();

  if (isViewOnly) {
    return null;
  }

  if (isExistingVariantPack) {
    return <AlreadyInOrderAction />;
  }

  return (
    <Button
      loading={isLoading}
      onPress={async () => {
        const maybePromise = onSelect();
        if (maybePromise && typeof maybePromise.then === 'function') {
          try {
            setIsLoading(true);
            await maybePromise;
          } finally {
            setIsLoading(false);
          }
        }
      }}
      style={styles.selectButton}
      testID="inbound-render-actions-select-button"
      textStyle={TYPOGRAPHY.h4SemiBold}
      trackingData={{
        name: 'inbound_render_actions.swap_item',
        properties: {
          isExistingVariantPack,
        },
      }}
      type="secondary"
    >
      {i18n.t('select')}
    </Button>
  );
};

const styles = StyleSheet.create({
  selectButton: {
    borderRadius: 8,
    borderWidth: 1,
    height: 40,
    paddingHorizontal: 16,
  },
});
